export const componentUniqueID = (component) => {
    return component.constructor['ɵcmp'].id;
}